import { useMemo } from 'react'

export const useInsightsSection = ({
	superpowers = [],
	blindspots = [],
	campusVibe = { blurb: '', chips: [] },
}) =>
	useMemo(
		() => ({
			superpowers,
			blindspots,
			campusVibe,
		}),
		[superpowers, blindspots, campusVibe],
	)

export default useInsightsSection

